var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.947 43.3459C21.0381 43.4047 21.1425 43.4399 21.2507 43.448C21.3589 43.4562 21.4674 43.4372 21.5664 43.3927L23.2499 42.6354V44.7499C23.2499 44.9222 23.3184 45.0876 23.4403 45.2095C23.5622 45.3314 23.7275 45.3999 23.8999 45.3999C23.9928 45.4001 24.0846 45.3802 24.169 45.3414L25.1999 44.8727V52.5499C25.1999 52.7222 25.2684 52.8876 25.3903 53.0095C25.5122 53.1314 25.6775 53.1999 25.8499 53.1999H55.7499C55.9223 53.1999 56.0876 53.1314 56.2095 53.0095C56.3314 52.8876 56.3999 52.7222 56.3999 52.5499V30.691L59.919 29.0914C59.9985 29.0552 60.07 29.0034 60.129 28.9391C60.1881 28.8747 60.2335 28.7991 60.2627 28.7168C60.2919 28.6344 60.3042 28.5471 60.2989 28.4599C60.2935 28.3727 60.2707 28.2875 60.2317 28.2093L59.3249 26.4004L60.5645 25.8427C60.6444 25.8068 60.7162 25.7551 60.7757 25.6907C60.8351 25.6264 60.8809 25.5507 60.9104 25.4682C60.9398 25.3857 60.9523 25.2981 60.947 25.2106C60.9417 25.1232 60.9188 25.0377 60.8797 24.9593L59.5797 22.3593C59.5047 22.21 59.3751 22.0952 59.2177 22.039C59.0604 21.9827 58.8874 21.9892 58.7347 22.0571L21.0347 38.9571C20.9202 39.0082 20.823 39.0914 20.7547 39.1966C20.6864 39.3018 20.65 39.4245 20.6499 39.5499V42.7999C20.6499 42.9084 20.677 43.0153 20.7289 43.1107C20.7808 43.206 20.8558 43.2869 20.947 43.3459ZM27.7999 51.8999H26.4999V44.2819L27.7999 43.691V51.8999ZM34.2999 51.8999H29.0999V43.1002L34.2999 40.7361V51.8999ZM36.8999 51.8999H35.5999V40.1453L36.8999 39.5544V51.8999ZM43.3999 51.8999H38.1999V38.9649L43.3999 36.6015V51.8999ZM45.9999 51.8999H44.6999V36.0093L45.9999 35.4185V51.8999ZM52.4999 51.8999H47.2999V34.827L52.4999 32.4649V51.8999ZM55.0999 51.8999H53.7999V31.8727L55.0999 31.2819V51.8999ZM24.5499 43.7404V42.0504L58.1406 26.9347L58.7672 28.1879L24.5499 43.7404ZM21.9499 39.9704L58.697 23.4981L59.4159 24.9353L21.9499 41.7943V39.9704Z",
    fill: "#867662"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_76_423)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 40,
    r: 39.5,
    stroke: "#867662",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_76_423",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_76_423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_76_423",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIcon);
export default __webpack_public_path__ + "static/media/ic-icon.b69ab4325de6217ee1b3761cd48a7a85.svg";
export { ForwardRef as ReactComponent };